export default __webpack_public_path__ + "static/media/button_google_play.d0b8186e.png";